module.exports = __webpack_public_path__ + "static/04-b48e6fb17e6dfbf59cce8ed0641098ca.jpg";